import { render, staticRenderFns } from "./LastData.vue?vue&type=template&id=61437e85&scoped=true&"
import script from "./LastData.vue?vue&type=script&lang=js&"
export * from "./LastData.vue?vue&type=script&lang=js&"
import style0 from "./LastData.vue?vue&type=style&index=0&id=61437e85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61437e85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VHover,VIcon})
